import { getPlaceData } from '@pcln/build-shop-search-form'
import { formatDate } from './date-helper'

const getComponentsFromTripType = (tripType, option) => {
  let index = 0

  const addProductToComponents = (productItem, components, shouldUnshift) => {
    const updatedComponents = [...components]

    if (shouldUnshift) {
      updatedComponents.unshift(productItem)
    } else {
      updatedComponents.push(productItem)
    }
    index += 1
    return updatedComponents
  }

  // eslint-disable-next-line no-shadow
  const addHotelToComponents = (components, option) => {
    const productItem = {
      productId: 5,
      index,
      type: 'STAY',
      query: {
        totalNumRooms: option.roomCount,
        ...(option.isPartialStayDateValid
          ? {
              travelStartDate: {
                value: option.hotelStartDate
              },
              travelEndDate: {
                value: option.hotelEndDate
              }
            }
          : {})
      }
    }

    return addProductToComponents(productItem, components, true)
  }

  const addFlightToComponents = components => {
    const productItem = {
      productId: 1,
      index,
      type: 'FLY',
      query: {
        includeBasicEconomy: option.includeBasicEconomy
      }
    }

    return addProductToComponents(productItem, components)
  }

  const getRCPlaceData = carLocation => ({
    ...getPlaceData(carLocation),
    cityName: carLocation.cityName,
    lat: carLocation.lat,
    lon: carLocation.lon,
    stateCode: carLocation.stateCode,
    postalCode: carLocation.postalCode,
    addressLine1: carLocation.addressLine1
  })

  // eslint-disable-next-line no-shadow
  const addCarToComponents = (components, option) => {
    const productItem = {
      productId: 8,
      type: 'DRIVE',
      index,
      ...(option.isCarRequired ? {} : { isRequired: false })
    }

    if (
      option.pickupCarSomewhere &&
      option.rcPickupDate &&
      option.rcDropoffDate &&
      option.rcLocation
    ) {
      const productItemWithQuery = {
        ...productItem,
        query: {
          pickupDateTime: `${formatDate(option.rcPickupDate, 'yyyy-MM-dd')}T${
            option.rcPickupTime
          }`,
          returnDateTime: `${formatDate(option.rcDropoffDate, 'yyyy-MM-dd')}T${
            option.rcDropoffTime
          }`,

          pickupLocation: getRCPlaceData(option.rcLocation),
          returnLocation: getRCPlaceData(option.rcLocation),
          isIncludeAirportLocations: option.pickupCarIncludeAirport
        }
      }

      return addProductToComponents(productItemWithQuery, components)
    }

    return addProductToComponents(productItem, components)
  }

  // eslint-disable-next-line no-shadow
  const mapComponent = (components, type, option) => {
    switch (type) {
      case 'STAY':
        return addHotelToComponents(components, option)
      case 'FLY':
        return addFlightToComponents(components, option)
      case 'DRIVE':
        return addCarToComponents(components, option)
      default:
        return components
    }
  }

  return tripType
    .split(':')
    .reduce((components, type) => mapComponent(components, type, option), [])
}

export default getComponentsFromTripType
